import { InlineImage } from "../../components/InlineImage";

/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function Na1900() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Neerbosch na 1900</h1>
          <h3>St Dominicuscollege</h3>
          <InlineImage image="neerbosch/neerbosch_1931.jpg" width={400} subscript="Neerbosch in 1822" />
          <p>
            Bij de kerkstraat aan de Dennenstraat (de huidige Dr. de Blécourtstraat) stond vroeger een buitengoed, genaamd de Witte Poort. De naam komt voor het eerst voor in de
            17e eeuw. Later wordt op deze plaats het St. Dominicuscollege van de paters Dominicanen gebouwd. De paters betrekken in 1927 het nieuwe klooster- en collegecomplex St.
            Dominicus College. Dit complex en de uitbreiding uit 1953 werden in 1993 gesloopt. In 1968 werd de nieuwbouw van het Dominicus College in gebruik genomen aan de
            Dorpstraat 13 (thans Energieweg 93). De bouw uit 1968 is nadien uitgebreid en in 2006 gesloopt om plaats te maken voor nieuwbouw. De straten die in 1994 zijn aangelegd
            op de plaats waar vanaf 1927 het St. Dominicus College heeft gestaan, zijn genoemd naar schrijvers die een relatie met Nijmegen hebben: Tjalie Robinson, Frans
            Kellendonk, Nescio en Jan Brinkhoff. Waarbij men aan het Jan Brinkhoffplantsoen de oude bestaan van de Witte Poort blijkbaar in herinnering heeft willen roepen, waarmee
            niet iedereen even gelukkig is. Zo schrijft publicist Herman van Run in 2003: "Op de plaats van het oude college zien we nu achter een flatgebouw dat de gedachte aan
            een 'poort' oproept (kennelijk ter herinnering aan het buitenhuis 'De Witte Poort' dat daar eens stond) rijen woningen die in al hun burgerlijkheid wel 'villa's' zullen
            heten. Twee namen op straatnaambordjes zijn gelukkig van hoger allooi: Dr. Jan Brinkhoff, de oer-Nijmeegse classicus die zowel leerling als leraar op het college
            geweest is, en de nog altijd intrigerende Frans Kellendonk, eens leerling.".
          </p>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h3>Het slotje van de Baron</h3>
          <p>
            In 1906 kwam het landgoed Hoogerhuizen in handen van de notaris jonkheer Eugène van Rijckevorsel van Kessel. Twee jaar later liet hij hierop een buitenhuis bouwen. Het
            op een sprookjeskasteel lijkend gebouw werd ontworpen door de Nijmeegse architect Willem Hoffmann en draagt de toepasselijke naam "'t Slotje". 't Slotje bleef tot in
            1973 eigendom van de familie. Korte tijd heeft er een kindertehuis in gezeten, daarna was het een hotel-restaurant. Het slotje heeft even te koop gestaan en men wilde
            zelfs een loterij uitschrijven waarbij de winnaar de eigenaar van 't Slotje zou worden. Daarover zou dan echter kansspelbelasting betaald moeten worden en dus ging dat
            plan niet door.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Na1900;
